import { Modal } from 'antd'
import React from 'react'
import { IoMdAlert } from 'react-icons/io'
import css from './index.scss'

const themes = {
  purple: '#7906a9',
  red: '#EB5757',
}
const ConfirmationModal = ({
  antdModalProps,
  title = '',
  content = null,
  theme = 'purple',
}) => (
  <Modal title={null} width={500} {...antdModalProps}>
    <div className={css.contentWrapper}>
      {title && (
        <div className={css.titleWrapper} style={{ color: themes[theme] }}>
          <IoMdAlert />
          <span className={css.title} style={{ color: themes[theme] }}>
            {title}
          </span>
        </div>
      )}
      {content}
    </div>
  </Modal>
)

export default ConfirmationModal
